import { render } from "./SlideDetail.vue?vue&type=template&id=4021d3a7&scoped=true"
import script from "./SlideDetail.vue?vue&type=script&lang=js"
export * from "./SlideDetail.vue?vue&type=script&lang=js"

import "./SlideDetail.vue?vue&type=style&index=0&id=4021d3a7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4021d3a7"]])

export default __exports__